import React, { useState, useEffect, useMemo } from "react";
import {
  Ptag,
  OverlayLoader,
  IfComponent,
  HeaderDasNew,
  Chip,
  MainBody,
} from "components/core";
import http from "services/httpService";
import { SideNav, SideNavContent } from "components";
import { formatDateSequence, newFormatRupees } from "utlis/utils";
import {
  TopHeader,
  Body,
  HomeWrapper,
  Icon,
  Table,
  ButtonStyle,
} from "./styles";
import EditIcon from "assets/svgs/edit.svg";
import { useNavigate } from "react-router-dom";
import routes from "components/routes";
import { theme } from "../../theme";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { capitalize } from "lodash";
import PageHeader from "components/UniversalComponents/PageHeader";
import { Button, Tooltip } from "@mui/material";
import EmptyDataLottie from "components/EmptyDataLottie";
import BaseDateFromTo from "components/UniversalComponents/BaseDateFromTo";
import BaseNewDropDown from "components/core/BaseNewDropDown";
import filterByDateRangeAndProducts from "./utils";
import PaymentDocumentModa from "./PaymentDocumentModal";
import NewDateStandardInput from "components/UniversalComponents/NewDateStandardInput";
import useUser from "hooks/useUser";

const tableTitles = [
  "Product",
  "Type",
  "Total Employees",
  "Total Lives",
  "Issuance Date",
  "Total Amount",
  "Endorsement Number",
  "View Documents",
  "",
];

const GmcPaymentSummary = () => {
  const navigate = useNavigate();
  const company_name = localStorage.getItem("company_name");
  const userplan_id =
    localStorage.getItem("userplan_id") ||
    sessionStorage.getItem("userplan_id") ||
    "";
  const business_user_id = localStorage.getItem("id");

  const [loading, setLoading] = useState(true);
  const [overallData, setOverallData] = useState();
  const [tableData, setTableData] = useState();
  const [products, setProducts] = useState([]);
  const [dateRangeFrom, setDateRangeFrom] = useState();
  const [dateRangeTo, setDateRangeTo] = useState();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [open, setOpen] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [transactionDate, setTransactionDate] = useState();
  const { getRole } = useUser();
  const role = getRole();

  const getSummeryData = async () => {
    try {
      setLoading(true);
      const { data } = await http.get(`/business/get_payment_summary/`, {
        params: {
          // userplan_id,
        },
      });
      const productArray = data.reduce((acc, item) => {
        if (!acc.includes(item.product)) acc.push(item.product);
        return acc;
      }, []);
      setProducts(productArray);
      setOverallData(data);
      setTableData(data);
    } catch (ex) {
      console.log({ ex });
    } finally {
      setLoading(false);
    }
  };
  
  const showEditButton = useMemo(() => {
    return role == "admin";
  }, [role])

  console.log({showEditButton})

  useEffect(() => {
    (async function () {
      await getSummeryData();
    })();
  }, []);

  const getInvoiceUrl = (invoice_url) => {
    window.open(invoice_url);
  };

  const redirectToEdit = (data) => {
    navigate(`/${routes.ENDORSEMENT_EDIT}`, { state: data });
  };
  const tableHeaders = useMemo(() => {
    return tableTitles.map((title) => (
      <th style={{ padding: "1rem 0rem", width: "200px" }}>
        <TopHeader
          style={{
            flexDirection: "column",
          }}
        >
          <Ptag
            fontSize="14px"
            textAlign="center"
            color={theme.primaryColor}
            fontWeight="600"
          >
            {title}
          </Ptag>
          {["Total Employees", "Total Lives"].includes(title) && (
            <Ptag
              fontSize="10px"
              textAlign="center"
              color="#686666"
              fontWeight="400"
            >
              (Addition/Deletion)
            </Ptag>
          )}
        </TopHeader>
      </th>
    ));
  }, []);

  const renderChip = (number, addition) => {
    if (number <= 0) return;
    let bgColor = addition ? "#ECFDF3" : "#FEF3F2";
    let color = addition ? "#027A48" : "#B42318";
    let symbol = addition ? <AddIcon /> : <RemoveIcon />;

    return (
      <Chip
        style={{
          marginLeft: !addition ? "1rem" : "0rem",
          borderRadius: "11px",
        }}
        text={
          <span style={{ color, display: "flex", alignItems: "center" }}>
            {symbol} {number}
          </span>
        }
        background={bgColor}
      />
    );
  };

  const renderDocumentChip = (link, text) => {
    if (!link) return;

    return (
      <span
        style={{
          fontSize: "13px",
          color: "#2354D4",
          letterSpacing: 0,
          cursor: "pointer",
          fontFamily: "Inter",
          whiteSpace: "nowrap",
          textTransform: "capitalize",
          textDecoration: "underline",
        }}
        onClick={() => window.open(link)}
      >
        {text}
      </span>
    );

    return (
      <Chip
        background="#2354D4"
        style={{
          color: "white",
          padding: "1rem",
          fontSize: "1.2rem",
          textTransform: "capitalize",
          cursor: "pointer",
          textDecoration: "underline",
        }}
        text={text}
        onClick={() => window.open(link)}
      />
    );
  };

  const getTotalAmount = (value) => {
    var total_amount =
      (value.cgst || 0) +
      (value.igst || 0) +
      (value.sgst || 0) +
      (value.net_premium || 0);
    return newFormatRupees(total_amount);
  };
  const extractFilteredData = () => {
    const filteredData = filterByDateRangeAndProducts(
      overallData,
      [dateRangeFrom, dateRangeTo],
      selectedProducts
    );
    // console.log(filteredData)
    setTableData(filteredData);
  };
  const clearValues = () => {
    setDateRangeFrom();
    setDateRangeTo();
    setSelectedProducts([]);
    setTableData(overallData);
  };
  const openModal = (documents, date) => {
    const filenames = Object.values(documents).filter((link) => {
      return link !== null;
    });
    console.log(filenames);
    setOpen(true);
    setDocuments(filenames);
    setTransactionDate(date);
  };
  const renderPaymentSummery = () => {
    return (
      <MainBody style={{ position: "relative" }}>
        <PageHeader header={"Enrolment History"} />
        <PaymentDocumentModa
          onOpen={open}
          documents={documents}
          handleOpen={setOpen}
          transactionDate={transactionDate}
        />
        {overallData && overallData.length > 0 ? (
          <IfComponent condition={tableData && tableData.length >= 0}>
            <div style={{ overflow: "auto" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "minmax(0, 1fr) 1fr 1fr 0.5fr",
                  gap: "2rem",
                  marginBottom: "32px",
                  alignItems: "flex-end",
                }}
              >
                <div style={{ gridColumn: "span 1" }}>
                  <Ptag
                    fontSize="14px"
                    fontWeight="400"
                    color="rgba(87, 95, 110, 1)"
                  >
                    Products
                  </Ptag>
                  <BaseNewDropDown
                    label="Select Products"
                    options={products}
                    values={selectedProducts}
                    onChange={setSelectedProducts}
                  />
                </div>

                <div style={{ gridColumn: "span 1" }}>
                  <Ptag
                    fontSize="14px"
                    fontWeight="400"
                    color="rgba(87, 95, 110, 1)"
                  >
                    Issuance Date
                  </Ptag>
                  <NewDateStandardInput
                    label="From"
                    value={dateRangeFrom}
                    onChange={setDateRangeFrom}
                    maxDate={dateRangeTo}
                  />
                </div>

                <div style={{ gridColumn: "span 1" }}>
                  <NewDateStandardInput
                    label="To"
                    value={dateRangeTo}
                    onChange={setDateRangeTo}
                    minDate={dateRangeFrom}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    gridColumn: "span 1",
                    justifyContent: "flex-start",
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={clearValues}
                    sx={clearButtonStyles}
                  >
                    Clear
                  </Button>

                  <Button
                    variant="contained"
                    onClick={extractFilteredData}
                    sx={applyButtonStyles}
                  >
                    Apply
                  </Button>
                </div>
              </div>
              <Table
                id="table-to-xls"
                className="table-striped"
                width="100%"
                cellSpacing="0"
                cellPadding="6"
                showBottomBorder={tableData && tableData.length != 1}
              >
                <tbody>
                  <tr style={{ backgroundColor: theme.cardBackgroundColor }}>
                    {tableHeaders}
                  </tr>
                  {tableData &&
                    tableData.map((payment_data, index) => {
                      return (
                        <tr key={index} style={{ background: "transparent" }}>
                          <td>
                            <TopHeader>
                              <Ptag fontSize="14px">
                                {payment_data.product}
                              </Ptag>
                            </TopHeader>
                          </td>
                          <td>
                            <TopHeader>
                              <Ptag fontSize="14px">
                                {payment_data.type
                                  ? capitalize(payment_data.type)
                                  : "-"}
                              </Ptag>
                            </TopHeader>
                          </td>
                          <td>
                            <TopHeader>
                              {renderChip(
                                payment_data.no_of_employees_added || 0,
                                true
                              )}
                              {renderChip(
                                payment_data.no_of_employees_deleted || 0
                              )}
                            </TopHeader>
                          </td>
                          <td>
                            <TopHeader>
                              {renderChip(
                                payment_data.no_of_lives_added || 0,
                                true
                              )}
                              {renderChip(
                                payment_data.no_of_lives_deleted || 0
                              )}
                            </TopHeader>
                          </td>
                          <td>
                            <TopHeader>
                              <Ptag fontSize="14px">
                                {(payment_data.transaction_date &&
                                  formatDateSequence(
                                    payment_data.transaction_date
                                  )) ||
                                  "-"}
                              </Ptag>
                            </TopHeader>
                          </td>
                          <td>
                            <TopHeader
                              style={{
                                justifyContent: "flex-end",
                              }}
                            >
                              <Ptag fontSize="14px" textAlign="center">
                                {getTotalAmount(payment_data)}
                              </Ptag>
                            </TopHeader>
                          </td>
                          <td>
                            <TopHeader>
                              {payment_data.endorsement_number ? (
                                <Tooltip
                                  arrow
                                  title={
                                    <Ptag color="white">
                                      {payment_data.endorsement_number}
                                    </Ptag>
                                  }
                                  style={{
                                    fontSize: "14px !important",
                                  }}
                                >
                                  <Ptag
                                    fontSize="14px"
                                    className="truncate-hover"
                                    textAlign="center"
                                  >
                                    {payment_data.endorsement_number || "-"}
                                  </Ptag>
                                </Tooltip>
                              ) : (
                                "-"
                              )}
                            </TopHeader>
                          </td>
                          <td>
                            <TopHeader
                              style={{
                                gap: "0.8rem",
                                justifyContent: "center",
                              }}
                            >
                              <Ptag
                                style={{
                                  fontSize: "13px",
                                  color: "#2354D4",
                                  letterSpacing: 0,
                                  cursor: "pointer",
                                  fontFamily: "Inter",
                                }}
                                onClick={() =>
                                  openModal(
                                    payment_data.documents,
                                    payment_data?.transaction_date
                                  )
                                }
                              >
                                View
                              </Ptag>
                            </TopHeader>
                          </td>
                          <td>
                            {showEditButton && (
                              <TopHeader
                                onClick={() => redirectToEdit(payment_data)}
                                style={{ cursor: "pointer" }}
                              >
                                <Icon src={EditIcon} />
                              </TopHeader>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </div>
          </IfComponent>
        ) : (
          <EmptyDataLottie text="No Data Availble" />
        )}
      </MainBody>
    );
  };

  return (
    <>
      <SideNav>{business_user_id && <SideNavContent />}</SideNav>
      <HeaderDasNew company_name={company_name} />
      {loading ? <OverlayLoader /> : renderPaymentSummery()}
    </>
  );
};

export default GmcPaymentSummary;

const buttonStyles = {
  fontSize: "14px",
  textTransform: "none",
  border: "1px solid",
  height: "40px",
  boxShadow: "none",
};

const clearButtonStyles = {
  ...buttonStyles,
  backgroundColor: "white",
  color: "rgba(34, 27, 60, 1)",
  "&:hover": {
    backgroundColor: "white",
    boxShadow: "none",
  },
};

const applyButtonStyles = {
  ...buttonStyles,
  color: "rgba(228, 219, 255, 1)",
  backgroundColor: "rgba(34, 27, 60, 1)",
  "&:hover": {
    backgroundColor: "rgba(34, 27, 60, 1)",
    boxShadow: "none",
  },
};
